import React from 'react';
import styles from './notFound.module.css';
import NotFoundImage from '../../Assets/Icons/not_found.svg';
import Header from '../../Components/Header/Header';

const NotFound = () => {
    return (
        <div>
            <Header width="100%" showLogo={true} showEnv={false} height={"93px"} />
            <div className={styles.contentOuter}>
                <img className={styles.imgLogo} src={NotFoundImage} alt="404 Not Found" />
                <h1 className={styles.mainText}>Page Not Found</h1>
                <p className={styles.subText}>Page you are looking for doesn't exist or has been moved.</p>
            </div>
        </div>
    );
};

export default NotFound;
